<template>
    <div class="card-news" @click="sendTo(item)">
        <v-img :img="item.img" :key="item.img.url" :is-video="isVideo"/>
        <div class="card-info">
            <span class="card-date">{{item.published_date}}</span>
            <h5 class="card-title" v-html="item.title"></h5>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import watchContent from '../../plugins/watchContent'

    export default {
        name: 'VCard',
        props: {
            layout: {
                type: String,
                required: true,
            },
            item: {
                type: Object,
                required: true,
            },
            internalPage: Boolean,
            isVideo: Boolean,
        },
        methods: {
            sendTo(item) {
                this.$watchContent(item)
                let url = item.uri
                if(!this.internalPage)
                    window.open(url,"_blank")
                else
                    window.location.href = url
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Card.vue